import React, { useState, useContext,  useEffect } from "react";
import "../Styles.css";
import "../../common/fileUploads/uploadsStyles.css";
import "../../../ui-styles/contentHeading/contentHeading.css";
import "../../../ui-styles/list/FormList.css";
import "../../../ui-styles/tabStyles/HztlTabStyles.css";
import "../../doctor/doctorProfile/doctorProfile.css";
import "../../../ui-styles/profile/VrtclProfile.css";
import "../../../ui-styles/profile/ProfileDetails.css";
import "../../../ui-styles/centerBlock/centerBlock.css";
import "../../../ui-styles/buttons/ButtonTxt.css";
import "../../../layouts/Layouts.css";
import "../../doctor/doctorSettings/doctorSettings.css";
import { LangCtx, PayLoadCtx } from "../../../lib/context";
import Button from "../../../lib/ui/buttons/Button";
import InputField from "../../../lib/ui/inputs/Input";
import { getStipeDetials, updateStripeDetails } from "../../../actions/users";
import { toast } from "react-toastify";
import Loader from "../../../lib/ui/loader/Loader";
import {API} from 'aws-amplify';

const StripeConfig = (props) => {
    const { l } = useContext(LangCtx);
    const { payload } = useContext(PayLoadCtx);
    //const [domain, setDomain] = useState(custom.subDomain)
    const [loading, setLoading] = useState(false);
    const [secretKey, setSecretKey] = useState("");
    const [pubKey, setPubKey] = useState("");
    const [edit, setEdit] = useState(false);
    // const s_ref = useRef(null);

    const [keyObj, setKeyObj] = useState({});

    // const handleEdit = (id) => {
    //     switch (id) {
    //         case "sig":
    //             s_ref.current.click();
    //             break;
    //         default:
    //             break;
    //     }
    // };

    const onEdit = () => {
        setEdit((prev) => !prev);
        setSecretKey("");
    };

    const handleCancelEdit = () => {
        setPubKey(keyObj.public);
        setSecretKey(keyObj.secret);
        setEdit((prev) => !prev);
    };

    useEffect(() => {
        getDetails();
    }, []);

    const getDetails = () => {
        setLoading(true);
        getStipeDetials(payload.userId)
            .then((res) => {
                setLoading(false);
                if (res.status) {
                    if (res.data != null && (res.data.serverstripekey || res.data.clientstripekey)) {
                        setSecretKey(res.data.serverstripekey);
                        setPubKey(res.data.clientstripekey);
                        setKeyObj({ public: res.data.clientstripekey, secret: res.data.serverstripekey });
                        setEdit(true);
                    }
                }
            })
            .catch((err) => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
                console.log("err ==== ", err);
            });
    };

    const handleSave = () => {
        let body = {
            serverstripekey: secretKey,
            clientstripekey: pubKey,
        };
        try {
            setLoading(true);
            updateStripeDetails(body)
                .then((res) => {
                    setLoading(false);
                    if (res.status) {
                        toast.success("stripe details saved successfully", {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        getDetails();
                    }
                })
                .catch((err) => {
                    setLoading(false);
                });
        } catch (e) {
            setLoading(false);
            toast.error("Failed to save stipe details!", {
                position: toast.POSITION.TOP_RIGHT,
            });
            console.log("Error", e);
        }
    };

    return (
        <div className="colBlock nopdng pos-rel">
            {loading && <Loader />}
            <div className="formCol">
                <div className="formListGroup">
                    {/**** Form  *****/}
                    <form>
                        <small className="inpLabel">
                            {l.secret_key}
                            <span className="redTxt">*</span>:
                        </small>
                        <div className={`inputRowFeild ${edit ? "disabledStripeInput" : ""}`}>
                            <InputField
                                placeholder={l.secret_key}
                                type="text"
                                value={secretKey}
                                disabled={edit}
                                onChange={(e) => setSecretKey(e.target.value)}
                            />
                        </div>
                        <small className="inpLabel">
                            {l.pub_key}
                            <span className="redTxt">*</span>:
                        </small>
                        <div className={`inputRowFeild ${edit ? "disabledStripeInput" : ""}`}>
                            <InputField
                                placeholder={l.pub_key}
                                type="text"
                                // value={pubKey}
                                value={pubKey}
                                disabled={edit}
                                onChange={(e) => setPubKey(e.target.value)}
                            />
                        </div>
                        <div className="crdBtnContainer">
                            <div className="rowBlock">
                                {edit ? (
                                    <Button label={l.edit} type="outLine" size="md" onClick={onEdit} />
                                ) : (
                                    <>
                                        <Button label={l.save} type="primary" size="md" onClick={handleSave} />

                                        <Button label={l.cancel} type="primary" size="md" onClick={handleCancelEdit} />
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="crdBtnContainer">
                            <div className="rowBlock">
                                <span>
                                    {l.stripe_link}
                                    <a className="linkTxt linkTxtMd" href="https://dashboard.stripe.com/register" target="_blank" rel="noopener noreferrer">
                                        {l.click_here}
                                    </a>
                                </span>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default StripeConfig;
